import apiClient from './apiClient';

export const notesApi = {
  async uploadPdf(file: File, classId: string, isPublic: boolean, title?: string) {
    const form = new FormData();
    form.append('file', file);
    form.append('class_id', classId);
    form.append('public', String(isPublic));
    if (title && title.trim()) form.append('title', title.trim());
    const res = await apiClient.post('/api/notes/pdf', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  async getNotes() {
    const res = await apiClient.get('/api/notes');
    return res.data.notes;
  },

  async getClassNotes(classId: string) {
    const res = await apiClient.get(`/api/notes/class/${classId}`);
    return res.data.notes;
  },

  async getNote(noteId: string) {
    const res = await apiClient.get(`/api/notes/${noteId}`);
    return res.data;
  },

  async getUserPublicNotes(userId: string) {
    const res = await apiClient.get(`/api/notes/user/${userId}`);
    return res.data.notes as Array<{ id: string; content: string; created_at: string; public: boolean; author?: any; cls?: any; title?: string; pdf_url?: string }>;
  },

  async deleteNote(noteId: string) {
    const res = await apiClient.delete(`/api/notes/${noteId}`);
    return res.data;
  },

  async getVotes(noteId: string) {
    const res = await apiClient.get(`/api/notes/${noteId}/votes`);
    return res.data as { count: number; user_has_voted: boolean };
  },

  async addVote(noteId: string) {
    const res = await apiClient.post(`/api/notes/${noteId}/votes`);
    return res.data as { count: number; user_has_voted: boolean };
  },

  async removeVote(noteId: string) {
    const res = await apiClient.delete(`/api/notes/${noteId}/votes`);
    return res.data as { count: number; user_has_voted: boolean };
  },

  async getComments(noteId: string) {
    const res = await apiClient.get(`/api/notes/${noteId}/comments`);
    return res.data.comments as Array<{ id: string; content: string; created_at: string; user_id: string; parent_id?: string | null; author?: { first_name: string; last_name: string } }>;
  },

  async addComment(noteId: string, content: string, parentId?: string) {
    const res = await apiClient.post(`/api/notes/${noteId}/comments`, parentId ? { content, parent_id: parentId } : { content });
    return res.data as { id: string; content: string; created_at: string; user_id: string; parent_id?: string | null };
  },

  async deleteComment(noteId: string, commentId: string) {
    const res = await apiClient.delete(`/api/notes/${noteId}/comments/${commentId}`);
    return res.data;
  },
};
